import React, { useState } from 'react';

import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { H2, Page, LayoutSingleColumn, Button } from '../../components';
import { apiBaseUrl } from '../../util/api';

import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';

import css from './NewsletterPage.module.css';

const NewsletterPage = props => {
  const intl = useIntl();

  const [success, setSuccess] = useState(false);
  const [marketingAccept, setMarketingAccept] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const values = Object.fromEntries(formData.entries());
    const { email, nombre, apellido } = values;

    let responseMailSupport;
    let responseMailUser;
    let responseSubscriber;

    let subscriberId;

    responseSubscriber = await fetch(apiBaseUrl() + '/api/create-subscriber', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: nombre + ' ' + apellido,
        email,
        status: 'active',
        role: [17],
      }),
    });
    console.log(responseSubscriber, responseSubscriber.ok);
    if (responseSubscriber.ok) {
      const subscriberData = await responseSubscriber.json()
      subscriberId = subscriberData.id;
    }

    // Send e-mail to ALOKA support. Only for PROD environments.
    if (process.env.REACT_APP_ALOKA_ENV === 'production') {
      const msgSupport = `
        <p>Nueva suscripción al boletín de <strong>${nombre} ${apellido} (${email})</strong>.</p>
      `;
      responseMailSupport = await fetch(apiBaseUrl() + '/api/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nameFrom: 'Boletín de Aloka',
          from: 'hola@aloka.app',
          nameTo: 'Soporte de Aloka',
          to: 'hola@aloka.app',
          subject: intl.formatMessage({
            id: 'NewsletterPage.supportEmailSubject',
            defaultMessage: 'New newsletter subscription',
          }),
          html: msgSupport,
        }),
      });
    }

    // Send confirmation e-mail to user.
    const msgUser = `
      <p>Hola <strong>${nombre}</strong>,</p>
      <p>Te has suscrito correctamente al boletín de Aloka. A partir de ahora recibirás nuestras novedades y campañas en tu correo electrónico.</p>
      <p>Para darse de baja haga click en el siguiente enlace. <a href="/unsubscribe/${subscriberId}">Darse de baja</a></p>
      <p>El equipo de Aloka</p>
    `;
    responseMailUser = await fetch(apiBaseUrl() + '/api/send-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        nameTo: `${nombre} ${apellido}`,
        to: email,
        nameFrom: 'Soporte de Aloka',
        from: 'hola@aloka.app',
        subject:
          process.env.REACT_APP_ALOKA_ENV === 'development'
            ? '[TEST] Suscripción al boletín'
            : intl.formatMessage({
              id: 'NewsletterPage.userEmailSubject',
              defaultMessage: 'Newsletter subscription confirmed',
            }),
        html: msgUser,
      }),
    });

    if (
      process.env.REACT_APP_ALOKA_ENV === 'production' &&
      responseMailSupport.ok &&
      responseMailUser.ok
    ) {
      setSuccess(true);
    } else if (process.env.REACT_APP_ALOKA_ENV === 'development' && responseMailUser.ok) {
      setSuccess(true);
    } else {
      // Do nothing for now.
    }
  };

  if (success) {
    return (
      <Page
        title="Newsletter"
        schema={{
          '@context': 'http://schema.org',
          '@type': 'WebPage',
          name: 'Newsletter',
        }}
      >
        <LayoutSingleColumn
          topbar={
            <>
              <TopbarContainer currentPage="NewsletterPage" />
            </>
          }
          footer={<FooterContainer />}
          mainColumnClassName={css.mainColumn}
        >
          <div className={css.root}>
            <H2 as="h1" className={css.title}>
              <FormattedMessage id="NewsletterPage.heading"
                                defaultMessage="Subscribe to our newsletter" />
            </H2>
            <p className={css.subtitle}>
              <FormattedMessage
                id="NewsletterPage.subtitle"
                defaultMessage="Stay up to date with our latest news and offers. Subscribe and we'll keep you in the loop."
              />
            </p>
            <div className={css.contentwrapper}>
              <FormattedMessage
                id="NewsletterPage.success"
                defaultMessage="You have been subscribed with success."
              />
            </div>
          </div>
        </LayoutSingleColumn>
      </Page>
    );
  }

  return (
    <Page
      title="Newsletter"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: 'Newsletter',
      }}
    >
      <LayoutSingleColumn
        topbar={
          <>
            <TopbarContainer currentPage="NewsletterPage" />
          </>
        }
        footer={<FooterContainer />}
        mainColumnClassName={css.mainColumn}
      >
        <div className={css.root}>
          <H2 as="h1" className={css.title}>
            <FormattedMessage id="NewsletterPage.heading" defaultMessage="Subscribe to our newsletter" />
          </H2>
          <p className={css.subtitle}>
            <FormattedMessage
              id="NewsletterPage.subtitle"
              defaultMessage="Stay up to date with our latest news and offers. Subscribe and we'll keep you in the loop."
            />
          </p>
          <div className={css.contentwrapper}>
            <form className={css.form} onSubmit={handleSubmit}>

              <label htmlFor="nombre" className={css.label}>
                <FormattedMessage id="NewsletterPage.nombre" defaultMessage="First name*" />
              </label>
              <input type="text" id="nombre" name="nombre" className={css.input} required />

              <label htmlFor="apellido" className={css.label}>
                <FormattedMessage id="NewsletterPage.apellido" defaultMessage="Last name*" />
              </label>
              <input type="text" id="apellido" name="apellido" className={css.input} required />

              <label htmlFor="email" className={css.label}>
                <FormattedMessage id="NewsletterPage.email" defaultMessage="Email address*" />
              </label>
              <input type="email" id="email" name="email" className={css.input} required />

              <div className={css.checkboxWrapper}>
                <input
                  type="checkbox"
                  name="marketing"
                  value="true"
                  className={css.checkbox}
                  onChange={(event) => setMarketingAccept(event.target.checked)}
                  required
                />
                <FormattedMessage
                  id="NewsletterPage.marketing"
                  defaultMessage="I agree to receive marketing campaigns and promotional communications"
                />
              </div>

              <Button
                className={css.submitButton}
                type="submit"
                inProgress={false}
                disabled={!marketingAccept}
              >
                <FormattedMessage id="NewsletterPage.submitButton" defaultMessage="Subscribe" />
              </Button>
            </form>
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

export default NewsletterPage;
